import { render, staticRenderFns } from "./TokenInvalidModal.vue?vue&type=template&id=840a8082"
import script from "./TokenInvalidModal.vue?vue&type=script&lang=js"
export * from "./TokenInvalidModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports